module.exports = __webpack_public_path__ + "img/aai.b35df945.svg";